<template>
  <div>
    <van-form @submit="onSubmitFundAdd">
      <base-date v-if="!emp.disable" v-model="qc.begin_date" type="year-month" placeholder="请选择入缴费年月" label="缴费年月" />
      <base-input v-if="!emp.disable" v-model="qc.apply_salary" placeholder="请输入申报工资" label="申报工资" />
      <base-input v-model="qc.name" :rules="rules.name" :disabled="emp.disable" placeholder="请输入员工姓名" label="员工姓名" @focus="xa" />
      <base-input v-model="qc.id_card" :rules="rules.id_card" :disabled="emp.disabled" placeholder="请输入身份证号码" label="身份证号码" />
      <base-input v-model="qc.phone" :rules="rules.mobile" placeholder="请输入手机号" label="手机号" />
      <van-collapse v-model="qc.hold_nature" accordion>
        <van-collapse-item :title="'户口性质 :       ' + sf2" style="color:green;" name="1">
          <span v-for="(item, i) in sf" :key="i" style="cursor: pointer;padding-right: 20px; " @click="sfyz(item, i)">{{ item }}</span>
        </van-collapse-item>
      </van-collapse>
      <van-row type="flex" justify="space-between" style="text-align: center; padding-bottom: 10px;padding-top: 20px;">
        <van-col span="12"><van-button type="info" class="btn" @click="cancel">取消</van-button></van-col>
        <van-col span="12"><base-button :disabled="submitDisabled" type="info" native-type="submit" class="btn">提交</base-button></van-col>
      </van-row>

    </van-form>
    <div>
      <van-popup v-model="show" round position="bottom">
        <van-search v-model="emp.value" show-action label="姓名" placeholder="请输入搜索关键词" @search="onSearch">
          <template #action>
            <div @click="onSearch">搜索</div>
          </template>
        </van-search>
        <van-picker :columns="emp_name" show-toolbar @cancel="show = false" @confirm="onConfirm" />
      </van-popup>
    </div>
  </div>
</template>

<script>
import { Wxlist, ModifyX } from '@/api/Hremployee';
import { fundAdd } from '@/api/Hrfund';

import { billadd } from '@/api/Hrbill';
export default {
  name: 'FundEmployeeAdd',
  props: {
    qc: {
      type: Object,

      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      show: false,
      emp: {
        value: '',
        disabled: true
      },
      empList: [],
      emp_name: [],
      sf: ['外埠城镇', '外埠农村', '本市城镇', '本市农村'],
      sf2: '',
      submitDisabled: false,
      rules: {
        name: [{ required: true, pattern: this.CONST.REG_EXP.PERSON_NAME, message: '姓名不能少于2个字符' }],
        id_card: [{ required: true, pattern: this.CONST.REG_EXP.ID_CARD, message: '输入的身份证号码不符合规范' }],
        mobile: [{ required: true, pattern: this.CONST.REG_EXP.MOBILE, message: '输入的手机号码不符合规范' }]
      }
    };
  },
  beforeMount() {
    if (sessionStorage.getItem('who') === '0') {
      this.emp.disable = false;
      this.qc.name = '';
      this.emp.status = 2;
      this.qc.id_card = '';
      this.qc.apply_salary = '';
      this.query();
    } else {
      this.qc.emp_id = parseInt(sessionStorage.getItem('emp_id'));
      this.qc.name = sessionStorage.getItem('username');
      this.qc.id_card = sessionStorage.getItem('id_card');
      this.emp.disable = true;
      this.sf2 = sessionStorage.getItem('hold_nature') ? sessionStorage.getItem('hold_nature') : '';
      this.qc.phone = sessionStorage.getItem('phone');
    }
  },
  mounted() {

  },
  updated() {},
  methods: {
    sfyz(value, value1) {
      this.sf2 = value;
      this.qc.hold_nature = '0';
    },
    xa() {
      this.show = true;
      this.query();
    },
    onSearch() {
      this.query();
    },
    cancel() {
      this.$emit('close');
    },
    onConfirm(value, index) {
      console.log(this.empList[index].id_card === undefined);
      if (this.empList[index].id_card === undefined) {
        this.emp.disabled = false;
        this.qc.id_card = '';
      } else {
        this.qc.id_card = this.empList[index].id_card;
        this.emp.disabled = true;
      }
      this.qc.name = this.emp_name[index].text;
      if (this.emp_name[index].disabled) {
        this.toast('该员工已有公积金请重新选择！');
      } else {
        this.show = false;
      }
      if (this.empList[index].hold_nature !== undefined) {
        this.sf2 = this.empList[index].hold_nature;
      }
      this.qc.phone = this.empList[index].phone;
      if (this.empList[index].id !== undefined) {
        this.qc.emp_id = this.empList[index].id;
      }
      if (this.empList[index].client_id !== undefined) {
        this.qc.client_id = this.empList[index].client_id;
      }
    },
    onSubmitFundAdd() {
      this.submitDisabled = true;
      this.$toast.loading({
        message: '提交中',
        forbidClick: true
      });
      const qc = this._.cloneDeep(this.qc);

      billadd({
        client_id: parseInt(sessionStorage.getItem('client_id')),
        emp_id: qc.emp_id ? qc.emp_id : parseInt(sessionStorage.getItem('emp_id')),
        name: qc.name,
        add_month: qc.begin_date ? qc.begin_date : null,
        type: '公积金-增员',
        create_id: parseInt(sessionStorage.getItem('create_id')),
        status: this.emp.status ? this.emp.status : 1,
        apply_salary: parseInt(qc.apply_salary),
        phone: qc.phone,
        id_card: qc.id_card,
        check_type: 1
      }).then(resp => {
        if (resp.success) {
          ModifyX({
            id_card: qc.id_card,
            hold_nature: this.sf2,
            phone: qc.phone,
            id: qc.emp_id ? qc.emp_id : parseInt(sessionStorage.getItem('emp_id'))
          }).then(res => {

          });
          this.$toast.success(resp.msg);
          this.$emit('close');
        } else {
          this.$toast.fail(resp.msg);
        }
      });
    },
    query() {
      this.emp_name = [];
      this.empList = [];
      Wxlist({ client_id: parseInt(sessionStorage.getItem('client_id')), name: this.emp.value ? this.emp.value : null }).then(res => {
        for (let i = 0; i < res.rows.length; i++) {
          this.empList.push({
            id: res.rows[i].id,
            id_card: res.rows[i].id_card,
            name: res.rows[i].name,
            phone: res.rows[i].phone,
            client_id: res.rows[i].client_id,
            hold_nature: res.rows[i].hold_nature
          });
          this.emp_name.push({ text: res.rows[i].name, disabled: true });
          console.log(res.rows[i].hold_nature);
          if (res.rows[i].function_ids.indexOf('11') === -1 && res.rows[i].f_base === undefined) {
            this.emp_name[i].disabled = false;
          }
        }
      });
    }
  }
};
</script>

<style scoped>
.btn {
  display: block;
  margin: 0 auto;
  margin-top: 10px;
  width: 80%;
  font-size: 16px;
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/hr/fund/employee-add.vue